import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "feedbackStatusColor",
	standalone: true
})
export class FeedbackStatusColorPipe implements PipeTransform {
	transform(status: string): string {
		if (status === "OPEN") {
			return "#AD7928";
		} else if (status === "UNDER_REVIEW") {
			return "#8772C8";
		} else if (status === "ACKNOWLEDGED") {
			return "#EA7B67";
		} else if (status === "PRIORITIZED") {
			return "#457BB4";
		} else if (status === "IN_PROGRESS") {
			return "#B04F82";
		} else if (status === "DONE") {
			return "#268E6B";
		} else if (status === "CLOSED") {
			return "#C1615F";
		}
		return "#AD7928";
	}
}
